import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import MindbodyBanner from './img/mb-banner@2x.png';
import './index.scss';

const onStudioIdKeyPress = (event) => {
  const re = /[0-9@-]+/g;
  if (!re.test(event.key)) {
    event.preventDefault();
  }
};

export default class MindbodyAuthorization extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      studioId: this.props.softwares.studioId,
      mbStudioIdError: false,
      hasError: false,
    };

    this.onMindBodyStudioIdChange = this.onMindBodyStudioIdChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const newState = {};

    if (
      typeof nextProps.softwares.isSoftwareSaved === 'boolean' &&
      // && nextProps.softwares.isSoftwareSaved !== this.softwares.isSoftwareSaved
      nextProps.softwares.isSoftwareSaved === false
    ) {
      newState.hasError = true;
    }

    this.setState(newState);
  }

  onMindBodyStudioIdChange(event) {
    this.setState({
      studioId: event.target.value,
    });
  }

  onNextButtonClick() {
    const data = {
      studioId: this.state.studioId,
    };
    if (this.validate(data)) {
      this.props.setBookingSoftware(data);
    }
  }

  validate(data) {
    if (!data.studioId) {
      this.setState({
        mbStudioIdError: true,
      });

      return false;
    }

    this.setState({
      mbStudioIdError: false,
    });

    return true;
  }

  render() {
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {this.state.hasError ? (
            <p className="authorize-access__error">
              <i className="material-icons" aria-hidden="true">error</i>
              Sorry, this studio ID is either already in use or invalid. Please
              try a different studio ID!
            </p>
          ) : (
            undefined
          )}
          <div className="authorize-access__form__row form-group">
            <p className="authorize-access__heading">
              YOUR MINDBODY STUDIO ID*
            </p>
            <input
              className={classnames({
                'has-error': this.state.mbStudioIdError,
              })}
              type="text"
              value={this.state.studioId}
              onChange={this.onMindBodyStudioIdChange}
              onKeyPress={onStudioIdKeyPress}
            />
          </div>
        </form>
        <div className="authorize-access__link">
          <a
            href="https://mindbodyonline.zendesk.com/hc/en-us/articles/206398178-How-do-I-find-my-Client-ID"
            target="_blank"
            rel="noopener noreferrer"
          >
            How to find your MINDBODY studio ID?
          </a>
        </div>
        <div className="authorize-access__example">
          EXAMPLE
          <img src={MindbodyBanner} alt="Mindbody Banner" width="498" />
        </div>
        <div className="authorize-access__actions">
          <button
            className="btn btn--secondary btn--lg"
            type="button"
            onClick={this.props.onBackClick}
          >
            Go Back
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
          >
            NEXT
          </button>
        </div>
      </div>
    );
  }
}

MindbodyAuthorization.defaultProps = {
  setBookingSoftware: () => {},
  onBackClick: () => {},
  softwares: {
    studioId: '',
  },
};

MindbodyAuthorization.propTypes = {
  setBookingSoftware: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape({
    studioId: PropTypes.string,
  }),
};
